import React, { useEffect, useId, useState } from 'react';
import modalStyles from '../../../styles/components/UI/Custom/ConfirmationModal.module.css';
import styles from '../../../styles/components/Modal/Lead/LoginUrlTtlModal.module.css';

const DEFAULT_TTL = 3600;

export const LoginUrlTtlModal = ({
    isOpen,
    onClose,
    onConfirm,
    isLoading,
    theme,
    title,
    message,
    options,
    confirmText,
    cancelText,
}) => {
    const titleId = useId();
    const [selectedTtl, setSelectedTtl] = useState(DEFAULT_TTL);

    useEffect(() => {
        if (isOpen) {
            setSelectedTtl(DEFAULT_TTL);
        }
    }, [isOpen]);

    useEffect(() => {
        if (!isOpen) return undefined;

        const handleKeyDown = (event) => {
            if (event.key === 'Escape' && !isLoading) {
                onClose();
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [isLoading, isOpen, onClose]);

    if (!isOpen) return null;

    const isDark = theme === 'dark';

    return (
        <div
            className={modalStyles.modalOverlay}
            onMouseDown={(event) => {
                if (event.target === event.currentTarget && !isLoading) {
                    onClose();
                }
            }}
        >
            <div
                className={`${modalStyles.modalContent} ${isDark ? modalStyles.darkModalContent : ''}`}
                role="dialog"
                aria-modal="true"
                aria-labelledby={titleId}
            >
                <h3
                    id={titleId}
                    className={`${modalStyles.modalHeader} ${isDark ? modalStyles.darkModalHeader : ''}`}
                >
                    {title}
                </h3>

                <p className={`${modalStyles.modalMessage} ${isDark ? modalStyles.darkModalMessage : ''}`}>
                    {message}
                </p>

                <fieldset className={styles.options} disabled={isLoading}>
                    {options.map((option) => (
                        <label
                            className={`${styles.option} ${isDark ? styles.darkOption : ''}`}
                            key={option.value}
                        >
                            <input
                                type="radio"
                                name="login-url-ttl"
                                value={option.value}
                                checked={selectedTtl === option.value}
                                onChange={() => setSelectedTtl(option.value)}
                            />
                            <span>{option.label}</span>
                        </label>
                    ))}
                </fieldset>

                <div className={modalStyles.actionButtons}>
                    <button
                        type="button"
                        onClick={onClose}
                        disabled={isLoading}
                        className={`${modalStyles.baseButton} ${modalStyles.cancelButton} ${isDark ? modalStyles.darkCancelButton : ''}`}
                    >
                        {cancelText}
                    </button>
                    <button
                        type="button"
                        onClick={() => onConfirm(selectedTtl)}
                        disabled={isLoading}
                        className={`${modalStyles.baseButton} ${styles.confirmButton}`}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};
